import React from 'react';
import './BienEtre.css';
import { Link } from 'react-router-dom';
import { FaSpa, FaDumbbell, FaAppleAlt } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';

const BienEtre = () => {
  const { t } = useLanguage();
  const services = [
    {
      icon: <FaSpa size={40} color="#00c4ff" />,
      title: t('servicesPages.wellnessMassageTitle'),
      description: t('servicesPages.wellnessMassageBody'),
    },
    {
      icon: <FaDumbbell size={40} color="#00c4ff" />,
      title: t('servicesPages.wellnessTrainerTitle'),
      description: t('servicesPages.wellnessTrainerBody'),
    },
    {
      icon: <FaAppleAlt size={40} color="#00c4ff" />,
      title: t('servicesPages.wellnessNutritionTitle'),
      description: t('servicesPages.wellnessNutritionBody'),
    },
  ];

  return (
    <>
      {/* Section principale */}
      <section className="bien-etre-header">
        <div className="bien-etre-text">
          <h5>{t('servicesPages.label')}</h5>
          <h1>{t('servicesPages.wellnessTitle')}</h1>
          <p>{t('servicesPages.wellnessBody')}</p>
        </div>

        <div className="bien-etre-image-wrapper">
          <div className="purple-bar"></div>
          <img
            src="/images/service-bien-etre.webp"
            alt="Bien-être"
            className="bien-etre-main-image"
          />
        </div>
      </section>

      {/* Cartes */}
      <section className="bien-etre-cards">
        <h5>{t('servicesPages.label')}</h5>
        <h2>{t('servicesPages.wellnessCardsTitle')}</h2>
        <p>{t('servicesPages.wellnessCardsBody')}</p>

        <div className="bien-etre-card-grid">
          {services.map((service, index) => (
            <div key={index} className="bien-etre-card">
              <div className="icon">{service.icon}</div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <Link to="/prendre-rdv" className="rdv-button">
                {t('servicesPages.bookCta')} <span>+</span>
              </Link>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default BienEtre;
